import { render, staticRenderFns } from "./KAMForms.vue?vue&type=template&id=e36f5792&scoped=true"
import script from "./KAMForms.vue?vue&type=script&lang=ts"
export * from "./KAMForms.vue?vue&type=script&lang=ts"
import style0 from "./KAMForms.vue?vue&type=style&index=0&id=e36f5792&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e36f5792",
  null
  
)

export default component.exports